import  './consultation.scss'
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper";
import {images} from '../../constants'

const ConsultationSlider = () => {
  return (
    <div className='consultation-slider'>
      <Swiper pagination={true} modules={[Pagination, Autoplay]} className="mySwiper" autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}>
        <SwiperSlide>
          <img src={images.Slide1} alt='Slide 1'/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Slide2} alt='Slide 2'/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Slide3} alt='Slide 3'/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Slide4} alt='Slide 4'/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Slide5} alt='Slide 5'/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Slide6} alt='Slide 6'/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Slide7} alt='Slide 7'/>
        </SwiperSlide>
        
      </Swiper>
    </div>
  )
}

export default ConsultationSlider